export default __webpack_public_path__ + "static/media/automation-active.bddc51c6.svg";